import { CSSProperties, FC } from 'react'
import LightningIcon from './icons/LightningIcon'
import ConsumersIcon from './icons/ConsumersIcon'
import ClimatIcon, { IconProps } from './icons/ClimatIcon'
import MonitoringIcon from './icons/MonitoringIcon'
import { SettingsIcon } from './icons/SettingsIcon'
import InventoryIcon from './icons/InventoryIcon'
import { useTranslation } from 'react-i18next'
import { Flex } from 'antd'
import { Link } from 'react-router-dom'
import HomeIcon from './icons/HomeIcon'

interface CarrierOneTabsProps {
	hash: string
	disabled?: boolean
	sideBarShown: boolean
}

const CarrierOneTabs: FC<CarrierOneTabsProps> = ({
	hash,
	disabled,
	sideBarShown
}) => {
	const { t } = useTranslation()

	const sideBarTopStyles: CSSProperties = {
		width: 'min(769px, 100%)',
		borderRadius: '18px',
		height: '72px',
		minHeight: '72px',
		boxSizing: 'border-box',
		boxShadow: '0 18px 40px rgba(26, 48, 79, 0.12)',
		transition: 'all .35s ease-in-out',
		overflow: 'hidden',
		gap: '1px',
		border: '1px solid rgba(221, 226, 235, 0.9)'
	}

	const navBarTopStyles: CSSProperties = {
		width: 'calc(100% - 16px)',
		height: '68px',
		position: 'fixed',
		minHeight: '68px',
		left: '8px',
		bottom: '8px',
		boxSizing: 'border-box',
		boxShadow: '0 18px 40px rgba(26, 48, 79, 0.18)',
		zIndex: 5,
		borderRadius: '18px',
		overflow: 'hidden',
		border: '1px solid rgba(221, 226, 235, 0.9)'
	}

	const data: {
		Icon: FC<IconProps>
		text: string
		link: string
		disabled?: boolean
	}[] = [
		{
			Icon: HomeIcon,
			text: t('Home'),
			link: ''
		},
		{
			Icon: LightningIcon,
			text: t('Lightning'),
			link: '#lightning'
		},
		{
			Icon: ConsumersIcon,
			text: t('Consumers'),
			link: '#consumers'
		},
		{
			Icon: ClimatIcon,
			text: t('Climat'),
			link: '#climat'
		},
		{
			Icon: MonitoringIcon,
			text: t('Monitoring'),
			link: '#monitoring'
		},
		{
			Icon: InventoryIcon,
			text: t('Inventory'),
			link: '#inventory'
		},
		{
			Icon: SettingsIcon,
			text: t('Settings'),
			link: '#settings',
			disabled
		}
	]
	return (
		<Flex
			style={sideBarShown ? sideBarTopStyles : navBarTopStyles}>
			{data
				.filter((d) =>
					sideBarShown ? d : d.link !== '#settings'
				)
				.map(({ Icon, link, text, disabled }, i) => (
					<Link
						to={disabled ? '#' : link}
						key={i}
						style={{
							flex: 1,
							flexBasis: 125,
							backgroundColor:
								hash === link ||
								(link !== '' &&
									hash.includes(link + '-'))
									? `var(--default)`
									: '#fff',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							textDecoration: 'none',
							gap: sideBarShown ? 8 : 4,
							cursor: disabled
								? 'not-allowed'
								: 'pointer',
							filter: disabled
								? 'grayscale(100%)'
								: 'none',
							padding: sideBarShown ? '8px 6px' : '6px 4px'
						}}>
						<Icon
							selected={
								hash === link ||
								(link !== '' &&
									hash.includes(link + '-'))
							}
						/>
						<p
							style={{
								color:
									hash === link ||
									(link !== '' &&
										hash.includes(link + '-'))
										? '#fff'
										: '#142D49',
								fontSize: sideBarShown ? 11 : 10,
								margin: 0,
								textAlign: 'center',
								lineHeight: 1.1
							}}>
							{sideBarShown ? text.toUpperCase() : text}
						</p>
					</Link>
				))}
		</Flex>
	)
}

export default CarrierOneTabs
